











































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Validator } from 'vee-validate';

import SingleCreditCard from './components/PaymentTypes/SingleCreditCard/SingleCreditCard.vue';
import CreditCards from './components/PaymentTypes/CreditCards/CreditCards.vue';
import CreditCardPix from './components/PaymentTypes/CreditCardPix/CreditCardPix.vue';
import PaymentActions from '../../../PaymentActions/PaymentActions.vue';

import Modal from '@/shared/components/Modal/Modal.vue';
import RadioBox from '@/shared/components/RadioBox/RadioBox.vue';
import EarlyRenewal from '@/shared/components/EarlyRenewal/EarlyRenewal.vue';
import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';

import { ECardStep, EPaymentMethod, EPaymentMethodTypes } from '@/helpers/enums';

import { ICreditCard } from '@/interfaces/CreditCard';
import {
  ICheckout,
  ICheckoutCartOffer,
  ICheckoutCartCustomerPaymentProfile,
} from '@/interfaces/Checkout';

import { Payment } from '@/classes/Checkout/Payment';
import { ICustomPaymentParameters } from '@/interfaces/CustomPaymentParameters';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');

type Option = {
  key: string,
  label: string,
  cmp: string,
  ref: string,
  props: any
};

@Component({
  components: {
    Modal,
    RadioBox,
    EarlyRenewal,
    PaymentActions,
    ScreenSizeVisibility,
    SingleCreditCard,
    CreditCards,
    CreditCardPix,
  },
})
export default class CreditCard extends Vue {
  @Prop()
  private readonly mobile?: boolean;

  @Prop()
  private readonly type?: EPaymentMethodTypes;

  @Prop()
  private readonly active?: boolean;

  @Prop({ default: () => new Validator() })
  private readonly validator: Validator;

  @Prop()
  private readonly isUpsell!: boolean;

  @Prop()
  private readonly validatePaymentType!: Function;

  @Prop({
    default: () => ({
      card_flag: null,
      card_number: '',
      owner_name: '',
      cvv: '',
      expiration_date: '',
      installment: 1,
      token: null,
    })
  })
  private readonly value: ICreditCard;

  private cardFirstDigits: any = null;

  activeOption: Option | null = null;

  @CheckoutModule.State
  private readonly modalPayment!: boolean;

  @CheckoutModule.Mutation
  private readonly toggleModalPayment!: Function;

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get wrapper () {
    return this.isMobile
      ? 'Modal'
      : 'div';
  }

  @AppModule.Action
  private prepareCheckout: Function;

  @AppModule.Mutation
  private setCardFirstDigits: Function;

  @CheckoutModule.State(state => state.checkout)
  private checkout: ICheckout;

  @CheckoutModule.Getter
  private rootOffer: ICheckoutCartOffer;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment: Payment;

  @CheckoutModule.Getter('selectedOffer')
  private offer: ICheckoutCartOffer;

  @CheckoutModule.Getter('selectedOfferPaymentCardStep')
  private cardStep: ECardStep;

  @CheckoutModule.Mutation
  private selectOfferPaymentCard: Function;

  @CheckoutModule.Mutation
  private setFilterCreditCard: Function;

  @CheckoutModule.Mutation
  private setRefCreditCardFormActived: Function;

  @CheckoutModule.Getter('isRenewal')
  private isRenewal: boolean;

  @CheckoutModule.Getter
  private renewalContractId: number | null;

  @CheckoutModule.Mutation('selectOfferPaymentCardInstallment')
  private selectOfferPaymentCardInstallment: Function;

  @CheckoutModule.Getter('selectedOfferPaymentCardSelected')
  private selectedPaymentCard: any;

  @CheckoutModule.State
  private enableHiddenMethods: boolean;

  @AppModule.Mutation
  private setCardSelected: Function;

  @AppModule.State
  private stepFormSelected: any;

  @AppModule.State
  private cardFirstDigitsSelected: string | number | null;

  @AppModule.State
  private isAmountLoading: boolean;

  private setPaymentCardInstallment (installment: number) {
    this.selectOfferPaymentCardInstallment({
      offer_id: this.offer.id,
      installment,
    });
  }

  private sendCardDigits() {
    this.getDiscountsBin();
  }

  private async getBinDiscountByCardSelected() {
    let slug: any = this.rootOffer.slug;

    if (this.isRenewal) {
      slug = this.renewalContractId;
    }

    await this.prepareCheckout({
      slug,
      payload: {
        card_first_digits: this.cardFirstDigitsSelected,
        payment_method: EPaymentMethodTypes.creditCard,
      },
      ...(this.enableHiddenMethods) && {
        enableHiddenMethods: this.enableHiddenMethods,
      }
    });
  }

  private prepareCheckoutOrUpsell(cardId: number) {
    this.setCardSelected(cardId);

    this.setCardFirstDigits(this.cardFirstDigitsSelected);

    this.getDiscountsBin();
  }

  private getDiscountsBin() {
    if (this.isUpsell) {
      const payloadNew = {
        card_first_digits: this.cardFirstDigitsSelected,
        payment_method: EPaymentMethodTypes.creditCard,
        ...(this.enableHiddenMethods) && {
          enableHiddenPaymentMethods: this.enableHiddenMethods,
        },
      };
      this.$emit('updateUpsell', payloadNew);
    } else {
      this.getBinDiscountByCardSelected();
    }
  }

  private selectPaymentCard (cardId: number) {
    this.selectOfferPaymentCard({
      offer_id: this.offer.id,
      card_id: cardId,
    });

    this.prepareCheckoutOrUpsell(cardId);
  }

  private setCardStep(cardStep: any) {
    this.$emit('setCardStep', cardStep);
  }

  private closeModal() {
    this.$emit('closeModal');
  }

  private setActive(key: string): void {
    const option = this.options.find(opt => opt.key === key);

    if (option) {
      this.activeOption = option;
      this.setFilterCreditCard(this.activeOption.key);
      this.setRefCreditCardFormActived(this.activeOption.ref);
    }
  }

  private async getEligibilityByAmount(customPaymentParamenters: ICustomPaymentParameters) {
    let slug = this.rootOffer.slug;

    if (this.$route.name === 'renew') {
      slug = this.$route.params.slug;
    }

    const payload = {
      ...this.cardFirstDigitsSelected && {
        card_first_digits: this.cardFirstDigitsSelected,
      },
      payment_method: EPaymentMethodTypes.creditCard,
      ...customPaymentParamenters && customPaymentParamenters!.input_amount && {
        custom_payment_parameters: customPaymentParamenters,
      },
    };

    if(this.isUpsell) {
      await this.$emit('updateUpsell', {
        ...payload,
        ...(this.enableHiddenMethods) && {
          enableHiddenPaymentMethods: this.enableHiddenMethods,
        },
      });
    } else {
      await this.prepareCheckout({
        slug,
        payload,
        ...(this.enableHiddenMethods) && {
          enableHiddenMethods: this.enableHiddenMethods,
        }
      });
    }

  }

  private get creditCard () {
    return this.payment.getPaymentMethod(EPaymentMethod.creditCard);
  }

  private get customerMainCreditCard(): any {
    return this.payment.cards.main;
  }

  private buildCreditCardInstallment(number: number, amount: number) {
    return `
      ${number}x ${this.$t('App.of')}
      ${this.$n(amount, 'currency')}
      ${number === 1 && amount > 0 && this.creditCardMethod.discount_percentage
    ? `(${this.creditCardMethod.discount_percentage}% de desconto)`
    : ''}
    `;
  }

  private get showForm() {
    return !this.mobile
      ? this.cardStep === this.stepFormSelected || this.cardStep === this.cardSteps.new || !this.creditCards
      : this.cardStep === this.stepFormSelected || this.cardStep === this.cardSteps.new;
  }

  private get showSelect() {
    return !this.mobile
      ? this.cardStep === this.cardSteps.select && this.creditCards
      : this.cardStep === this.cardSteps.select;
  }

  private get cardSteps() {
    return ECardStep;
  }

  private get creditCardMethod() {
    return this.payment.getPaymentMethod(EPaymentMethod.creditCard);
  }

  private get creditCardSelectedInstallment() {
    return this.creditCardMethod.installment;
  }

  private get creditCards() {
    return this.payment.cards.options;
  }

  private get creditCardInstallmentsTreated() {
    const installments = this.payment.cards.installments;

    return (
      installments &&
      installments.map((installment: any) => {
        return {
          ...installment,
          text: this.buildCreditCardInstallment(
            installment.number,
            installment.amount
          )
        };
      })
    );
  }

  private get paymentTypeSelected () {
    return this.payment.selectedPaymentType;
  }

  private get paymentTypes () {
    return EPaymentMethodTypes;
  }

  private get additionalPaymentStructure() {
    let additionalPaymentStructure: any = null;
    const paymentStructures: any = this.offer.payment_structure && this.offer.payment_structure.filter((payment_structure: any) => {
      return payment_structure.is_multi_payment_options;
    });

    additionalPaymentStructure = paymentStructures.map((paymentStructure: any) => {
      const payment_method_code = paymentStructure.payment_conditions.reduce((a: any, b: any) => {
        return `${a.payment_method_code}_${b.payment_method_code}`;
      });

      return {
        payment_method_code,
        ...paymentStructure,
      };
    });

    return additionalPaymentStructure;
  }

  private get options() {
    const opts: Option[] = [];

    opts.push({
      label: 'Um cartão',
      key: 'single-credit-card',
      cmp: 'SingleCreditCard',
      ref: 'singleCreditCard',
      props: {
        isActive: true,
      },
    });

    if (this.additionalPaymentStructureIsAvailable('creditcard_creditcard')) {
      opts.push({
        label: 'Dois cartões',
        key: 'creditcard-creditcard',
        cmp: 'CreditCards',
        ref: 'creditCards',
        props: {
          paymentConditions: this.getAdditionalPaymentStructure(this.additionalPaymentStructure, 'creditcard_creditcard' ),
        },
      });
    }

    if (this.additionalPaymentStructureIsAvailable('creditcard_pix')) {
      opts.push({
        label: 'Cartão + Pix',
        key: 'creditcard-pix',
        cmp: 'CreditCardPix',
        ref: 'creditCardPix',
        props: {
          paymentConditions: this.getAdditionalPaymentStructure(this.additionalPaymentStructure, 'creditcard_pix' ),
        },
      });
    }

    return opts;
  }

  private isActive(key: string): boolean {
    return this.activeOption !== null && this.activeOption.key === key;
  }

  private additionalPaymentStructureIsAvailable(method: any) {
    return this.additionalPaymentStructure && this.additionalPaymentStructure.find((item: any) => item.payment_method_code === method);
  }

  private getAdditionalPaymentStructure(paymentStructure: any, method: any) {
    return paymentStructure && paymentStructure.find((item: any) => item.payment_method_code === method);
  }

  @Watch('isAmountLoading')
  private onChange(value: boolean) {
    !value && this.activeOption && this.setActive(this.activeOption.key);
  }

  mounted() {
    this.setActive('single-credit-card');
  }
}
